<div class="chip-colored-container" [ngStyle]="{background:color}">
    <app-circle-avatar [img]="prefixAvatar" [width]="prefixAvatarWidth" [height]="prefixAvatarHeight" *ngIf="prefixAvatar"></app-circle-avatar>
    <img [src]="prefixImg" alt="" *ngIf="prefixImg">
    <span [ngClass]="labelClass" [ngStyle]="{color:labelColor}">{{label|translate}}</span>
    <div class="close-container">
        <i class="fas fa-close" *ngIf="showClose" [ngStyle]="{color:closeColor}" role="button" (click)="click()"></i>
    </div>
</div>